export default __webpack_public_path__ + "static/media/f.bb97ebde.mp3";